// consts
import alertsStyle from './consts/alertsStyle';
import articleStyle from './consts/articleStyle';
import bps from './consts/bps';
import breadCrumbsStyle from './consts/breadCrumbsStyle';
import breakingNewsStyle from './consts/breakingNewsStyle';
import btnStyle from './consts/btnStyle';
import captionStyles from './consts/captionStyles';
import commentsStyle from './consts/commentsStyle';
import fontStacks from './consts/fontStacks';
import footerStyle from './consts/footerStyle';
import gridStyle from './consts/gridStyle';
import inputStyle from './consts/inputStyle';
import layoutStyle from './consts/layoutStyle';
import magazineArticleStyle from './consts/magazineArticleStyle';
import mastheadStyle from './consts/mastheadStyle';
import marketingBannerStyle from './consts/marketingBannerStyle';
import mobileStyle from './consts/mobileStyle';
import navMenuStyle from './consts/navMenuStyle';

import { listStyle, benderStyle, } from './consts/listStyle';
import audioPlayerStyle from './consts/audioPlayerStyle';
import cardStyle from './consts/cardStyle';
import newsletterStyle from './consts/newsletterStyle';
import searchEngineStyle from './consts/searchEngineStyle';
import selectStyle from './consts/selectStyle';
import serviceByMailStyle from './consts/serviceByMailStyle';
import specialPromotionStyle from './consts/specialPromotionStyle';
import topNewsStyle from './consts/topNewsStyle';
import osakaStyle from './consts/osakaStyle';
import paywallStyle from './consts/paywallStyle';
import quoteStyle from './consts/quoteStyle';
import typeConf from './consts/typeConf';
import zenPopup from './consts/zenPopup';
import {
  teaserI18n,
  a11yMenuI18n,
  alertsI18n,
  adsI18n,
  articleLayoutI18n,
  audioPlayerI18n,
  breadcrumbsI18n,
  breakingNewsStrip,
  clickTrackerI18n,
  coastHeaders,
  commentI18n,
  commentFormI18n,
  commentSentI18n,
  commentsSectionI18n,
  commentsCountI18n,
  commercialListI18n,
  creditPrefixI18n,
  errorPageI18n,
  footerDesktopI18n,
  footerSocialLinksI18n,
  footerMobileListsI18n,
  fryListI18n,
  galleryI18n,
  greetingsI18n,
  homepageLogoLink,
  shareBarI18n,
  headerSearchI18n,
  hotTopicsI18n,
  liveBlogI18n,
  magazineExclusivesI18n,
  mastheadSubscriptionI18n,
  mobileAdditionalShare,
  mobileNavigationMenuI18n,
  mobileQuickRegistrationI18n,
  mobileSearchI18n,
  mobileUserMenuI18n,
  navigationMenuI18n,
  newsletterI18n,
  osakaI18n,
  paywallI18n,
  podcastChannelNames,
  podcastChannelTitle,
  podcastI18n,
  promotionsI18n,
  tldrPromotionLink,
  ratingI18n,
  survey,
  surveyPie,
  readingListMenuI18n,
  readingListUpdateI18n,
  recipeIngredientsI18n,
  recipeInstructionsI18n,
  recipeTipsI18n,
  recipeRatingI18n,
  reviewRatingI18n,
  recipesSearchI18n,
  seoI18n,
  seriesArticleI18n,
  serviceByMailI18n,
  tagsElementI18n,
  tateI18n,
  textInputI18n,
  tldrDefaultContent,
  topNewsI18n,
  userMenuI18n,
  welcomePageI18n,
  zenTextI18n,
  zoominText,
  zoomoutText,
  selectAriaLabel,
  marketingTools,
  footballHeaders,
  nbaHeaders,
  groupBarTabs,
  btnOptions,
  universityTitlesI18n,
  timeLabels,
  zenNonPayingUsers,
  adBlockPage,
  dayMap,
  pushwooshCustomPopup,
  words,
} from './consts/i18n';

// methods
import getColor from './methods/getColor';
import getDelay from './methods/getDelay';
import getDuration from './methods/getDuration';
import getTimingFunction from './methods/getTimingFunction';
import getTransition from './methods/getTransition';
import getTransitionString from './methods/getTransitionString';
import getMqString from './methods/getMqString';
import getZIndex from './methods/getZIndex';
import pxToRem from './methods/pxToRem';
import typesetter from './methods/typesetter';
import mq from './methods/mq';

/**
 * Haaretz theme object
 */
const hdcTheme = Object.freeze({
  // Constants
  alertsStyle,
  articleStyle,
  audioPlayerStyle,
  benderStyle,
  bps,
  breadCrumbsStyle,
  breakingNewsStyle,
  btnStyle,
  captionStyles,
  commentsStyle,
  direction: 'ltr',
  gridStyle,
  fontStacks,
  footerStyle,
  // font for elements that are framed (mainly relevant for haaretz.com)
  framedFont: 'alt',
  inputStyle,
  listStyle,
  layoutStyle,
  logoType: 'hdc',
  magazineArticleStyle,
  mobileStyle,
  mastheadStyle,
  marketingBannerStyle,
  navMenuStyle,
  cardStyle,
  newsletterStyle,
  searchEngineStyle,
  selectStyle,
  serviceByMailStyle,
  specialPromotionStyle,
  topNewsStyle,
  osakaStyle,
  paywallStyle,
  quoteStyle,
  typeConf,
  zenPopup,

  // I18n
  teaserI18n,
  a11yMenuI18n,
  alertsI18n,
  adsI18n,
  articleLayoutI18n,
  audioPlayerI18n,
  breadcrumbsI18n,
  breakingNewsStrip,
  clickTrackerI18n,
  coastHeaders,
  commentI18n,
  commentFormI18n,
  commentSentI18n,
  commentsSectionI18n,
  commentsCountI18n,
  commercialListI18n,
  creditPrefixI18n,
  errorPageI18n,
  footerDesktopI18n,
  footerSocialLinksI18n,
  footerMobileListsI18n,
  fryListI18n,
  homepageLogoLink,
  galleryI18n,
  greetingsI18n,
  headerSearchI18n,
  hotTopicsI18n,
  liveBlogI18n,
  magazineExclusivesI18n,
  mastheadSubscriptionI18n,
  mobileAdditionalShare,
  mobileNavigationMenuI18n,
  mobileQuickRegistrationI18n,
  mobileSearchI18n,
  mobileUserMenuI18n,
  navigationMenuI18n,
  newsletterI18n,
  osakaI18n,
  podcastI18n,
  promotionsI18n,
  tldrPromotionLink,
  paywallI18n,
  podcastChannelNames,
  podcastChannelTitle,
  ratingI18n,
  readingListMenuI18n,
  readingListUpdateI18n,
  recipeIngredientsI18n,
  recipeInstructionsI18n,
  recipeTipsI18n,
  reviewRatingI18n,
  recipeRatingI18n,
  recipesSearchI18n,
  seoI18n,
  seriesArticleI18n,
  serviceByMailI18n,
  tagsElementI18n,
  tateI18n,
  textInputI18n,
  tldrDefaultContent,
  topNewsI18n,
  userMenuI18n,
  welcomePageI18n,
  words,
  zenTextI18n,
  zoominText,
  zoomoutText,
  selectAriaLabel,
  marketingTools,
  survey,
  surveyPie,
  universityTitlesI18n,
  timeLabels,
  zenNonPayingUsers,
  adBlockPage,
  dayMap,
  pushwooshCustomPopup,
  // Methods
  color: getColor,
  getDelay,
  getDuration,
  getTimingFunction,
  getTransition,
  getTransitionString,
  getMqString,
  getZIndex,
  mq,
  pxToRem,
  shareBarI18n,
  footballHeaders,
  nbaHeaders,
  groupBarTabs,
  btnOptions,
  type: typesetter,
});

export default hdcTheme;
